class ConversionTableEntry {
    fromValue: string;
    toValue: string;
}

class ConversionTable {
    fromUnitName: string;
    toUnitName: string;
    rows: ConversionTableEntry[];
}

class RelatedConversionEntry{
    fromUnit: string;
    fromUnitName: string;
    toUnit: string;
    toUnitName: string;
}

class RelatedConversionTable{
    fromUnit: string;
    fromUnitName: string;
    rows: RelatedConversionEntry[];
}

class ConversionPageContract {
    unitConversion: UnitConversion;

    fromRelatedConversions: UnitConversion[];
    toRelatedConversions: UnitConversion[];

    conversionTable: ConversionTable;
    relatedConversionTable: RelatedConversionTable;

    conversionReadmeMarkdown: string;
    fromUnitReadmeMarkdown: string;
    toUnitReadmeMarkdown: string;
}

export interface Measure {
    measure: string;
    measureName: string;
}

class MeasurePageContract {
    unitConversions: UnitConversion[]
}

class HomePageContract {
    unitConversions: UnitConversion[]

    groupByMeasure(): { [key: string]: UnitConversion[] } {
        var map: { [key: string]: UnitConversion[] } = {};
        this.unitConversions
            .sort((a, b) => a.fromUnit.localeCompare(b.fromUnit))
            .forEach(unitConversion => {
                if (!map[unitConversion.measure]) {
                    map[unitConversion.measure] = [];
                }
                map[unitConversion.measure].push(unitConversion)
            });
        return map;
    }
}

export class UnitInfo {
    measure: string;
    measureName: string;
    unit: string;
    unitName: string;
}

export class UnitConversion {
    measure: string;
    measureName: string;
    fromUnit: string;
    fromUnitName: string;
    toUnit: string;
    toUnitName: string;
}

export namespace UnitConversion {
    export function linkName(unitConversion: UnitConversion): string {
        return `${unitConversion.fromUnitName} to ${unitConversion.toUnitName}`;
    }

    export function linkUrlPart(unitConversion: UnitConversion): string {
        return `${unitConversion.fromUnitName.toLowerCase()}-to-${unitConversion.toUnitName.toLowerCase()}`.replace(/ /ig, '-').replace(/\//ig, 'per');
    }
}